/**
 * @author lifei
 * 功能：将字母转成小写
 * @param str 字符串
 * @param mode capitalize 首字母小写，all 全部小写
 */
export const toLowerCase = (str: string, mode: 'capitalize' | 'all'): string => {
  switch (mode) {
    case 'all':
      return str.toLowerCase()
    case 'capitalize':
      return str.charAt(0).toLowerCase() + str.substring(1)
    default: {
      const _exhaustiveCheck: never = mode
    }
  }
  return str
}
